import styled from 'styled-components';

/** One step: the dot and its line on the left, the words on the right. */
export const Step = styled.li`
  position: relative;
  display: flex;
  gap: 16px;
  padding-bottom: 20px;

  &:last-child {
    padding-bottom: 0;
  }

  /* The line down to the next dot. Drawn by every step but the last, from
     under its own dot, so it always meets the next one whatever the text
     height. */
  &:not(:last-child)::before {
    content: '';
    position: absolute;
    left: 5px;
    top: 16px;
    bottom: 0;
    width: 2px;
    background: ${({ theme }) => theme.gray};
  }
`;

export const StepList = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
`;

/** Filled once the step happened, an outline while it is still ahead. */
export const StepDot = styled.span<{ $color: string; $done: boolean }>`
  flex: none;
  width: 12px;
  height: 12px;
  margin-top: 3px;
  border-radius: 50%;
  border: 2px solid ${({ $color }) => $color};
  background: ${({ $color, $done, theme }) => ($done ? $color : theme.white)};
`;
